import React from "react";
import MigracaoCards from "./Migracao/MigracaoCards";
import Card from "../../components/page/Card";
import MigracaoDataTable from "./Migracao/MigracaoDataTable";
import useApi from "../../hooks/useApi";
import TimelineApiClient from "../../api/timeline";
import NovoMigracaoModal from "./Migracao/NovoMigracaoModal";
import Format from "../../helpers/Format";
import ErrorSwal from "../../components/Swal/errorSwal";
import Validation from "../../helpers/Validation";
import CommonSwal from "../../components/Swal/commonSwal";
import OptionsSwal from "../../components/Swal/optionsSwal";
import NovoUsuarioModal from "./Migracao/NovoUsuarioModal";
import UsuariosMigracaoModal from "./Migracao/UsuariosMigracaoModal";
import UsuariosModal from "./Migracao/UsuariosModal";
import FastMigracaoModal from "./Migracao/FastMigracaoModal";

function Migracao() {
  const [values, setValues] = React.useState({});
  const [usuariosMigracao, setUsuariosMigracao] = React.useState({});
  const [usuarios, setUsuarios] = React.useState({});
  const [cards, setCards] = React.useState({});
  const [processos, setProcessos] = React.useState([]);
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [novoProcessoModal, setNovoProcessoModal] = React.useState(false);
  const [novoUsuarioModal, setNovoUsuarioModal] = React.useState(false);
  const [fastMigracaoModal, setFastMigracaoModal] = React.useState(false);
  const [usuariosMigracaoModal, setUsuariosMigracaoModal] =
    React.useState(false);
  const [usuariosModal, setUsuariosModal] = React.useState(false);

  const { request: getProcessos, data: procesosResponse } = useApi(
    TimelineApiClient.getProcessosMigracao
  );
  const novoProcessoMigracaoApi = useApi(
    TimelineApiClient.postProcessosMigracao
  );
  const deleteProcessoMigracaoApi = useApi(
    TimelineApiClient.deleteProcessoMigracao
  );
  const adicionarUsuarioMigracaoApi = useApi(
    TimelineApiClient.adicionarUsuarioMigracao
  );
  const getUsuarioMigracaoApi = useApi(TimelineApiClient.getUsuariosMigracao);
  const getAdministradoresMigracaoApi = useApi(
    TimelineApiClient.getAdministradoresMigracao
  );
  const getUsuariosApi = useApi(TimelineApiClient.getUsuarios);
  const getAdministradoresApi = useApi(TimelineApiClient.getAdministradores);
  const vincularUsuariosApi = useApi(TimelineApiClient.vincularUsuarios);
  const atualizarStatusUsuarioApi = useApi(
    TimelineApiClient.atualizarStatusUsuario
  );
  const fastProcessoMigracaoApi = useApi(
    TimelineApiClient.fastProcessoMigracao
  );

  //Busca processos ao renderizar tela
  React.useLayoutEffect(() => {
    getProcessos();
  }, [getProcessos]);

  //Define o retorno do backend nos valores das linhas
  React.useEffect(() => {
    if (!procesosResponse) return;
    const transformedProcessos = procesosResponse.map((linha) => ({
      ...linha,
      dados_empresa: JSON.parse(linha.dados_empresa),
    }));

    const processos = transformedProcessos.length;
    const valor_total = transformedProcessos.reduce((accumulator, processo) => {
      const mensalidade = parseFloat(processo?.dados_empresa?.mensalidade) || 0;
      return accumulator + (Number.isNaN(mensalidade) ? 0 : mensalidade);
    }, 0);
    const ticket_medio = processos > 0 ? valor_total / processos : 0;

    setCards({
      valor_total,
      processos,
      ticket_medio,
    });
    setProcessos(transformedProcessos);
  }, [procesosResponse]);

  const togNovoProcessoModal = () => {
    setValues({});
    setNovoProcessoModal(true);
  };

  const criarNovoProcesso = async () => {
    const formData = new FormData();
    formData.append("link_contrato", values?.link_contrato);
    formData.append("data_assinatura", values?.data_assinatura);
    formData.append("mensalidade", values?.mensalidade);
    formData.append("cnpj", Format.formatCNPJCPF(values?.cpf_empresa));
    formData.append("razao_social", values?.apelido_empresa);
    formData.append("email_empresa", values?.email_empresa);
    formData.append("celular_empresa", values?.celular_empresa);
    formData.append("inicio_prestacao", values?.inicio_prestacao);
    formData.append("numero_socios", values?.numero_socios);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    if (Validation.validaCnpj(values?.cpf_empresa))
      return ErrorSwal({
        text: "Favor inserir um CNPJ válido.",
      });

    if (Validation.validarEmail(values?.email_empresa))
      return ErrorSwal({
        text: "Favor inserir um e-mail válido.",
      });

    const response = await novoProcessoMigracaoApi.request(formData);
    if (!response) return;
    CommonSwal({ title: "Novo processo criado com sucesso!", icon: "success" });
    setNovoProcessoModal(false);
    getProcessos();
  };

  const deletarProcesso = (uid) => {
    OptionsSwal({
      icon: "question",
      title: "Você realmente deseja excluir esse processo?",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteProcessoMigracaoApi.request(uid);

        if (!response) return;
        CommonSwal({
          title: "Processo de abertura deletado",
          icon: "success",
        });
        getProcessos();
      }
    });
  };

  const togNovoUsuarioModal = (uid) => {
    setValues({ uid });
    setNovoUsuarioModal(true);
  };

  const salvarUsuario = async () => {
    const formData = new FormData();

    formData.append("email", values?.email);
    formData.append("usuario", values?.usuario);
    formData.append("senha", values?.senha);
    formData.append("uid", values?.uid);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    if (values?.senha !== values?.confirme_senha)
      return ErrorSwal({ text: "As senhas devem ser iguais." });

    if (Validation.validarEmail(values?.email))
      return ErrorSwal({
        text: "Favor preencher com um e-mail válido.",
      });

    const senhaErro = Validation.verificarSenha(values?.senha);
    if (senhaErro)
      return ErrorSwal({
        html: senhaErro,
      });

    const response = await adicionarUsuarioMigracaoApi.request(
      formData,
      values?.uid
    );
    if (!response) return;
    CommonSwal({
      title: "Processo finalizado com sucesso!",
      icon: "success",
    });
    setNovoUsuarioModal(false);
    getProcessos();
  };

  const togUsuariosMigracaoModal = async (uid) => {
    const response = await getUsuarioMigracaoApi.request(uid);
    if (!response) return;
    setValues({ uid });
    setIsAdmin(false);
    setUsuariosMigracao(response.usuarios);
    setUsuariosMigracaoModal(true);
  };

  const togAdministradoresMigracaoModal = async (uid) => {
    const response = await getAdministradoresMigracaoApi.request(uid);
    if (!response) return;
    setValues({ uid });
    setIsAdmin(true);
    setUsuariosMigracao(response.usuarios);
    setUsuariosMigracaoModal(true);
  };

  const togUsuariosModal = async () => {
    const response = await getUsuariosApi.request();
    if (!response) return;
    setUsuariosMigracaoModal(false);
    setValues((prevValues) => ({ uid: prevValues?.uid }));
    setUsuarios(response);
    setUsuariosModal(true);
  };

  const togAdministradoresModal = async () => {
    const response = await getAdministradoresApi.request();
    if (!response) return;
    setUsuariosMigracaoModal(false);
    setValues((prevValues) => ({ uid: prevValues?.uid }));
    setUsuarios(response);
    setUsuariosModal(true);
  };

  const vincularUsuarios = async () => {
    const formData = new FormData();
    formData.append("usuarios", JSON.stringify(values?.usuarios));

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await vincularUsuariosApi.request(formData, values?.uid);
    if (!response) return;
    CommonSwal({
      title: "Usuários vinculados com sucesso!",
      icon: "success",
    });
    setUsuariosModal(false);
    const response_usuarios = isAdmin
      ? await getAdministradoresMigracaoApi.request(values?.uid)
      : await getUsuarioMigracaoApi.request(values?.uid);
    setUsuariosMigracao(response_usuarios.usuarios);
    setUsuariosMigracaoModal(true);
  };

  const atualizarStatusUsuario = async (uid_colaborador, ativo) => {
    OptionsSwal({
      icon: "question",
      title: "Tem certeza que deseja alterar status deste usuário?",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("ativo", ativo ? "0" : "1");

        const response = await atualizarStatusUsuarioApi.request(
          formData,
          values?.uid,
          uid_colaborador
        );
        if (!response) return;

        const response_usuarios = isAdmin
          ? await getAdministradoresMigracaoApi.request(values?.uid)
          : await getUsuarioMigracaoApi.request(values?.uid);

        setUsuariosMigracao(response_usuarios.usuarios);
        CommonSwal({
          title: "Usuário atualizado com sucesso!",
          icon: "success",
        });
        getProcessos();
      }
    });
  };

  const togFastMigracaoModal = () => {
    OptionsSwal({
      icon: "question",
      title: "Tem certeza que deseja continuar?",
      text: "Os dados utilizados para a construção deste processo serão todos fictícios e não devem ser utilizados em um processo real.",
    }).then((result) => {
      if (result.isConfirmed) {
        setValues({});
        setFastMigracaoModal(true);
      }
    });
  };

  const fastProcessoMigracao = async () => {
    const formData = new FormData();
    formData.append("step", values?.step);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await fastProcessoMigracaoApi.request(formData);
    if (!response) return;
    CommonSwal({
      title: "Processo criado com sucesso!",
      icon: "success",
    });
    setFastMigracaoModal(false);
    getProcessos();
  };

  return (
    <>
      <div className="row">
        <MigracaoCards cards={cards} />
      </div>
      <Card>
        <MigracaoDataTable
          linhas={processos}
          deletarProcesso={deletarProcesso}
          togNovoUsuarioModal={togNovoUsuarioModal}
          togNovoProcessoModal={togNovoProcessoModal}
          togUsuariosModal={togUsuariosMigracaoModal}
          togAdministradoresMigracaoModal={togAdministradoresMigracaoModal}
          togFastMigracaoModal={togFastMigracaoModal}
        />
      </Card>
      <NovoMigracaoModal
        criarNovoProcesso={criarNovoProcesso}
        modalHook={{ novoProcessoModal, setNovoProcessoModal }}
        valuesHook={{ values, setValues }}
      />
      <NovoUsuarioModal
        criarUsuario={salvarUsuario}
        modalHook={{ novoUsuarioModal, setNovoUsuarioModal }}
        valuesHook={{ values, setValues }}
      />
      <UsuariosMigracaoModal
        modalHook={{ usuariosMigracaoModal, setUsuariosMigracaoModal }}
        usuarios={usuariosMigracao}
        togUsuariosModal={togUsuariosModal}
        togAdministradoresModal={togAdministradoresModal}
        isAdmin={isAdmin}
        atualizarStatusUsuario={atualizarStatusUsuario}
      />
      <UsuariosModal
        modalHook={{ usuariosModal, setUsuariosModal }}
        usuarios={usuarios}
        valuesHook={{ values, setValues }}
        vincularUsuarios={vincularUsuarios}
      />
      <FastMigracaoModal
        fastProcesso={fastProcessoMigracao}
        modalHook={{ fastMigracaoModal, setFastMigracaoModal }}
        valuesHook={{ values, setValues }}
      />
    </>
  );
}

export default Migracao;
